export const PreviewInfoObjectMap = {
    1 /* ObjectType.OBJECT_FACE */: {
        name: 'OBJECT_FACE',
        title: '人脸数据',
        attrs: {
            gender_code: '性别',
            st_age: '年龄',
            // skin_color: "肤色",
            glass_style: '眼镜款式',
            // ethic_code: "民族",
            mustache_style: '胡型',
            respirator_color: '口罩',
            cap_style: '帽子款式',
        },
        color: 'red',
        completion: '色',
        rectWidthLimit: 30,
        lineWidth: 3,
        opacity: 0,
    },
    2 /* ObjectType.OBJECT_PEDESTRIAN */: {
        name: 'OBJECT_PEDESTRIAN',
        title: '行人数据',
        attrs: {
            hair_color: '发色',
            hair_style: '发型',
            cap_style: '帽子款式',
            bag_style: '包款式',
            appendant: '附属物',
            st_coat_pattern: '上衣图案',
            st_trousers_pattern: '下装图案',
            coat_style: '上衣款式',
            coat_length: '上衣长度',
            trousers_len: '下装长度',
            cap_color: '帽子颜色',
            bag_color: '包颜色',
            umbrella_color: '伞颜色',
            coat_color: '上衣颜色',
            shoes_color: '鞋子颜色',
            respirator_color: '口罩颜色',
            shoes_style: '鞋子款式',
            trousers_color: '下装颜色',
            gender_code: '性别',
            // st_age: "年纪",
        },
        // 组装结果
        assemble: {
            gender: {
                // label: "性别",
                showField: ['gender_code'],
            },
            hair: {
                label: '头发',
                showField: ['hair_color', 'hair_style'],
                completion: '色',
            },
            coat: {
                label: '上衣',
                showField: ['coat_color', 'coat_style', 'coat_length'],
                completion: '色',
            },
            trousers: {
                label: '下装',
                showField: ['trousers_color', 'trousers_len'],
                completion: '色',
            },
            shoes: {
                label: '鞋子',
                showField: ['shoes_color', 'shoes_style'],
                completion: '色',
            },
            bag: {
                label: '包',
                showField: ['bag_color', 'bag_style'],
                completion: '色',
            },
            cap: {
                label: '帽子',
                showField: ['cap_color', 'cap_style'],
                completion: '色',
            },
            umbrella: {
                label: '伞',
                showField: ['umbrella_color'],
                completion: '色',
            },
            respirator: {
                label: '口罩',
                showField: ['respirator_color'],
                completion: '色',
            },
        },
        color: 'yellow',
        rectWidthLimit: 40,
        lineWidth: 3,
        opacity: 0,
    },
    3 /* ObjectType.OBJECT_AUTOMOBILE */: {
        name: 'OBJECT_AUTOMOBILE',
        title: '机动车数据',
        attrs: {
            // vehicle_brand: "车辆品牌",
            vehicle_model: '车辆型号',
            vehicle_color: '车辆颜色',
            vehicle_class: '车辆类型',
            plate_no: '车牌',
        },
        // 不需要匹配过滤，直接展示的字段
        noFiltration: ['vehicle_model', 'plate_no'],
        color: 'blue',
        completion: '色',
        rectWidthLimit: 100,
        lineWidth: 3,
        opacity: 0,
    },
    4 /* ObjectType.OBJECT_CYCLIST */: {
        name: 'OBJECT_CYCLIST',
        title: '骑手数据',
        attrs: {
            // st_direction: '方向',
            coat_color: '外衣颜色',
            hair_color: '头发颜色',
            hair_style: '发型',
            gender_code: '性别',
            st_age: '年纪',
            shoes_color: '鞋颜色',
        },
        color: 'red',
        completion: '色',
        rectWidthLimit: 50,
        lineWidth: 3,
        opacity: 0,
    },
    5 /* ObjectType.OBJECT_HUMAN_POWERED_VEHICLE */: {
        name: 'OBJECT_HUMAN_POWERED_VEHICLE',
        title: '非机动车数据',
        attrs: {
            // st_direction: "方向",
            vehicle_color: '车身颜色',
            st_vehicle_class: '车辆类型',
        },
        color: 'orange',
        completion: '色',
        rectWidthLimit: 60,
        lineWidth: 3,
        opacity: 0,
    },
    8 /* ObjectType.OBJECT_ALGO */: {
        color: '#fff',
        completion: '色',
        rectWidthLimit: 30,
        lineWidth: 3,
        opacity: 0,
    },
    6 /* ObjectType.OBJECT_CROWD */: {
        roi: {
            color: '#F7B500',
            fillColor: 'rgba(247, 181, 0, 0.5)',
        },
        queue_personnels: {
            color: '#E02020',
            lineWidth: 5,
        },
        queue_line: {
            color: '#E02020',
            lineWidth: 8,
        },
        color: '#fff',
        completion: '色',
        rectWidthLimit: 30,
        lineWidth: 3,
        opacity: 0,
    },
};
export const PreviewInfoEventMap = {
    'com.sensetime.algo.behavior.abnormal': {
        name: 'EVENT_PEDESTRIAN_STAY',
        title: '智慧教育',
        color: 'orange',
        lineWidth: 3,
        opacity: 0,
        key: 'type',
        eventType: {
            EVENT_PEDESTRIAN_HOVER: {
                name: '校内人员徘徊',
                type: '1004',
            },
            EVENT_PEDESTRIAN_CROSS_LINE: {
                name: '校内人员越线',
                type: '1005',
            },
            EVENT_PEDESTRIAN_INVADE: {
                name: '校内人员入侵',
                type: '1006',
            },
            EVENT_PEDESTRIAN_STAY: {
                name: '校内人员滞留',
                type: '1003',
            },
            EVENT_PEDESTRIAN_DEPARTURE: {
                name: '校内人员滞留',
                type: '1003',
            },
        },
    },
    'com.sensetime.algo.kitchen.staff': {
        name: 'alg-kitchen',
        title: '智慧市监',
        color: 'yellow',
        lineWidth: 3,
        opacity: 0,
        key: 'objectType',
        eventType: {
            ST_SMOKING: {
                name: '厨房人员吸烟',
                type: '2002',
            },
            ST_DRESSING: {
                name: '厨房人员未戴口罩或厨师帽',
                type: '1005',
            },
        },
    },
    'com.sensetime.algo.stall': {
        name: '街边伞棚占道',
        title: '智慧城管',
        color: 'orange',
        lineWidth: 3,
        opacity: 0,
        key: 'objectType',
        eventType: {},
    },
    'com.sensetime.algo.leftovers': {
        name: '车辆抛洒物品',
        title: '智慧城管',
        color: 'blue',
        lineWidth: 3,
        opacity: 0,
        key: 'objectType',
        eventType: {},
    },
    'com.sensetime.algo.shadow': {
        name: '视频夜间光点发现',
        title: '公安、刑侦',
        color: 'red',
        lineWidth: 3,
        opacity: 0,
        key: 'objectType',
        eventType: {},
    },
    'com.sensetime.algo.smoking': {
        name: '景区违规吸烟',
        title: '智慧政务',
        color: 'red',
        lineWidth: 3,
        opacity: 0,
        key: 'objectType',
        eventType: {},
    },
    'com.sensetime.algo.action': {
        name: '打架斗殴',
        title: '公安、治安防控',
        color: 'yellow',
        lineWidth: 3,
        opacity: 0,
        key: 'objectType',
        eventType: {},
    },
    'com.sensetime.algo.action.detect.feature': {
        name: '打架斗殴',
        title: '公安、治安防控',
        color: 'yellow',
        lineWidth: 3,
        opacity: 0,
        key: 'objectType',
        eventType: {},
    },
    'com.sensetime.algo.ads': {
        name: '',
        title: '城管、智慧城管',
        color: 'yellow',
        lineWidth: 3,
        opacity: 0,
        key: 'objectType',
        eventType: {
            ST_SLOGAN: {
                name: '横幅检测',
                type: '3005',
            },
            ST_BANNER: {
                name: '标语检测',
                type: '3006',
            },
        },
    },
    'com.sensetime.algo.sharedbicycle': {
        name: '',
        title: '城管、智慧城管',
        color: 'yellow',
        lineWidth: 3,
        opacity: 0,
        key: 'objectType',
        eventType: {
            ST_SHARED_BICYCLE: {
                name: '共享单车违规停放',
                type: '3009',
            },
            ST_SHARED_BICYCLE_FALLEN: {
                name: '共享单车杂乱摆放',
                type: '3010',
            },
        },
    },
    'com.sensetime.algo.construction': {
        name: '工地人员未戴安全帽',
        title: '住建、智慧工地',
        color: 'yellow',
        lineWidth: 3,
        opacity: 0,
        key: 'type',
        eventType: {},
    },
    'com.sensetime.algo.indoor': {
        name: '工作人员离岗',
        title: '政务、智慧政务',
        color: 'yellow',
        lineWidth: 3,
        opacity: 0,
        key: 'objectType',
        eventType: {},
    },
    'com.sensetime.algo.turdtruck': {
        name: '粪车偷排污水',
        title: '水利、智慧水务',
        color: 'yellow',
        lineWidth: 3,
        opacity: 0,
        key: 'type',
        eventType: {},
    },
    'com.sensetime.algo.fire': {
        name: '烟火检测',
        title: '应管、智慧应管',
        color: 'yellow',
        lineWidth: 3,
        opacity: 0,
        key: 'objectType',
        eventType: {},
    },
    'com.sensetime.algo.garbage': {
        name: '路面垃圾暴露',
        title: '城管、智慧城管',
        color: 'yellow',
        lineWidth: 3,
        opacity: 0,
        key: 'objectType',
        eventType: {},
    },
    'com.sensetime.algo.vehiclepark': {
        name: '机动车违规停放',
        title: '公安、智慧交管',
        color: 'yellow',
        lineWidth: 3,
        opacity: 0,
        key: 'type',
        eventType: {},
    },
    'com.sensetime.algo.behavior.supervised': {
        // 暂未配置
        name: '监管场所异常事件分析',
        title: '司法、智慧监所',
        color: 'yellow',
        lineWidth: 3,
        opacity: 0,
        key: 'type',
        eventType: {},
    },
    'com.sensetime.algo.roads.standing.water': {
        name: '水务',
        title: '智慧城管',
        color: 'yellow',
        lineWidth: 3,
        opacity: 0,
        key: 'type',
        eventType: {}, // 不是同算法下的多事件
    },
};
export const PreviewInfoScenarioMap = {
    0 /* ScenarioType.ST_UNKNOWN */: {
        name: '未知',
        color: 'red',
        lineWidth: 3,
        opacity: 0,
    },
    1 /* ScenarioType.ST_STALL */: {
        name: '违规占道经营',
        // tips:"占道经营事件",
        color: 'red',
        lineWidth: 3,
        opacity: 0,
    },
    2 /* ScenarioType.ST_FIRE */: {
        name: '烟火',
        // tips:"烟火检测事件",
        color: 'red',
        lineWidth: 3,
        opacity: 0,
    },
    3 /* ScenarioType.ST_SLOGAN */: {
        name: '臧疆标语检测',
        color: 'red',
        lineWidth: 3,
        opacity: 0,
    },
    4 /* ScenarioType.ST_LANDSCAPE_LAMP */: {
        name: '景观灯损坏',
        color: 'red',
        lineWidth: 3,
        opacity: 0,
    },
    5 /* ScenarioType.ST_CLUTTER */: {
        name: '工地堆放不当',
        color: 'red',
        lineWidth: 3,
        opacity: 0,
    },
    6 /* ScenarioType.ST_ROAD_CLEAN */: {
        name: '路面清洁',
        // tips:"工程车抛洒事件",
        color: 'red',
        lineWidth: 3,
        opacity: 0,
    },
    7 /* ScenarioType.ST_SOIL */: {
        name: '工地泥土覆盖',
        color: 'red',
        lineWidth: 3,
        opacity: 0,
    },
    8 /* ScenarioType.ST_GARBAGE */: {
        name: '打包垃圾检测',
        // tips:"垃圾满溢事件",
        color: 'red',
        lineWidth: 3,
        opacity: 0,
    },
    9 /* ScenarioType.ST_SHARED_BICYCLE */: {
        name: '共享单车分类 ',
        // tips:"共享单车违停",
        color: 'red',
        lineWidth: 3,
        opacity: 0,
    },
    10 /* ScenarioType.ST_SHARED_BICYCLE_MISORDER */: {
        name: '共享单车乱序摆放',
        // tips:"共享单车成片倾倒事件",
        color: 'red',
        lineWidth: 1,
        opacity: 0,
    },
};
export const PreviewInfoRectStyle = {
    textFont: '12px SourceHanSansCN',
    textColor: '#D5D5D5',
    textBaseline: 'middle',
    textDirection: 'inherit',
    fillColor: 'rgba(59,71,100,0.8)',
    lineColor: '#56668D',
    textIndent: 20,
    attrRectW: 124,
    attrRectH: 28,
    radius: 4,
    titleR: 3,
};
export const PreviewEventRectStyle = {
    textFont: '12px SourceHanSansCN',
    textColor: '#D5D5D5',
    textBaseline: 'middle',
    textDirection: 'inherit',
    fillColor: '#E04949',
    lineColor: '#E04949',
    textIndent: 10,
    attrRectW: 124,
    attrRectH: 28,
    radius: 4,
    titleR: 0,
    opacity: 0.5,
};
// export const TextStyle = {
//   //文字框背景颜色
//   textBackgroundColor: "#00000044",
//   //文字配置
//   textFont: "16px Arial",
//   //文字框宽度
//   //textFrameWidth:120,
//   //文字框每行递增
//   textFrameInterval: 20,
//   //文字框每行高度
//   textFrameHeightPerLine: 20,
//   //行间隔
//   lineSpace: 2,
//   //文字颜色
//   textColor: "#FFFFFF",
// };
// export const EventStyle = {
//   //持续时间,单位毫秒
//   eventTime: 500,
//   //告警颜色
//   eventColor: "red",
//   //文字框背景颜色
//   textBackgroundColor: "#000000CC",
//   //文字配置
//   textFont: "16px Arial",
//   //文字框宽度
//   //textFrameWidth:80,
//   //文字框每行递增
//   textFrameInterval: 30,
//   //文字框每行高度
//   textFrameHeightPerLine: 20,
//   //文字颜色
//   textColor: "#FFFFFF",
//   //透明度变化速度
//   opacitySpeed: 0.002,
// };
// export const HeatmapStyle = {
//   //文字内容
//   content: "关注区域内人数：",
//   //文字配置
//   textFont: "bold 36px Arial",
//   //距离上边
//   top: 50,
//   //距离右边
//   left: 20,
//   //文字颜色
//   textColor: "#FF0000",
//   textWidth: 200,
//   textHeight: 40,
// };
